var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrapor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7058 19.6486L30.8762 13.4782V16.3453L27.5729 19.6486H24.7058ZM20.8461 19.6486L28.9159 11.5789H30.8758V12.4861L23.713 19.649L20.8461 19.6486ZM17.8938 19.6486V18.7414L25.0566 11.5785H27.9238L19.854 19.6483L17.8938 19.6486ZM17.8938 17.7489V14.8817L21.1971 11.5784H24.0642L17.8938 17.7489ZM17.8938 13.8892V11.5785H20.2045L17.8938 13.8892ZM30.8766 10.175H17.8938V2.10518L30.8766 2.10518V10.175ZM9.67884 2.10518L3.50837 8.27565V5.40848L6.81167 2.10518H9.67884ZM3.50837 9.26805L10.6712 2.10518L13.5384 2.10518L5.46863 10.175H3.50869L3.50837 9.26805ZM14.5311 2.10518H16.4911V3.01241L9.3282 10.1753H6.46103L14.5311 2.10518ZM16.4911 4.00497V6.87214L13.1878 10.1754H10.3206L16.4911 4.00497ZM16.4911 7.86462V10.1754L14.1803 10.1754L16.4911 7.86462ZM5.81959 2.10526L3.50885 4.416L3.50885 2.10526L5.81959 2.10526ZM1.05263 0C0.472116 0 0 0.472116 0 1.05263L0 38.9474C0 39.5279 0.472116 40 1.05263 40C1.63315 40 2.10526 39.5279 2.10526 38.9474L2.10526 1.05263C2.10526 0.472116 1.63315 0 1.05263 0ZM3.50877 11.5793L16.4916 11.5793V19.6491H3.50877L3.50877 11.5793ZM28.5666 19.6491L30.8774 17.3384V19.6491H28.5666Z",
    fill: "#132640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrapor);
export default __webpack_public_path__ + "static/media/prapor.1b2d03ba.svg";
export { ForwardRef as ReactComponent };